import React from "react";
import PrestamoHeader from "./PrestamoHeader";
import { Container } from "semantic-ui-react";
import PrestamoList from "./PrestamoList";
import PrestamoListEmpty from "./PrestamoListEmpty";
import PropTypes from "prop-types";

const PrestamoDashboard = ({ creditos, fromInicioPage }) => {
  return (
    <Container
      className={fromInicioPage ? "containerSecundario" : "containerPrincipal"}
    >
      <PrestamoHeader />

      {creditos && creditos.length > 0 ? (
        <PrestamoList creditos={creditos} />
      ) : (
        <PrestamoListEmpty />
      )}
    </Container>
  );
};

PrestamoDashboard.propTypes = {
  creditos: PropTypes.array.isRequired,
};
export default PrestamoDashboard;
